// This file was auto-generated by Fern from our API Definition.
export const ObjectPropertyAccess = {
    ReadOnly: "READ_ONLY",
    WriteOnly: "WRITE_ONLY",
};
